export default "__VITE_ASSET__BtzmIKoN__"